import { AssessmentQuestionType } from '../../utils/assessmentsQuestions';
import { GradingQuestion } from './GradingQuestionType';

export enum GradingQuestionActionType {
  Init,
  UpdateGrade,
}

interface GradingQuestionInitAction {
  type: GradingQuestionActionType.Init;
  payload: {
    data: any[];
  };
}

interface UpdateGradeAction {
  type: GradingQuestionActionType.UpdateGrade;
  payload: {
    questionIndex: number;
    grade: number;
  };
}

export type GradingQuestionAction = UpdateGradeAction | GradingQuestionInitAction;

export const gradingQuestionsReducer = (
  state: GradingQuestion[],
  action: GradingQuestionAction,
) => {
  const { type } = action;
  if (type === GradingQuestionActionType.Init) {
    const data: GradingQuestion[] = action.payload.data.map((q, i) => {
      if (q.type === AssessmentQuestionType.TextInput) {
        return {
          type: AssessmentQuestionType.TextInput,
          questionIndex: i,
          questionId: q.id,
          text: q.text,
          maxGrade: q.maxGrade,
          grade: q.answer[0].grade,
          answerId: q.answer[0].id,
          answer: q.answer[0].textInputAnswer.text,
        };
      } else if (q.type === AssessmentQuestionType.MultipleChoice || q.type === AssessmentQuestionType.SingleChoice) {
        return {
          type: q.type,
          questionIndex: i,
          questionId: q.id,
          text: q.text,
          maxGrade: q.maxGrade,
          grade: q.answer[0].grade,
          answerId: q.answer[0].id,
          answer: q.answer[0].possibleChoice.map((d: { id: number; }) => d.id),
          possibleChoice: q.possibleChoice
        };
      } else {
        return {
          type: AssessmentQuestionType.FileUpload,
          questionIndex: i,
          questionId: q.id,
          text: q.text,
          maxGrade: q.maxGrade,
          grade: q.answer[0].grade,
          answerId: q.answer[0].id,
        };
      }
    });
    state = data;
  } else if (type === GradingQuestionActionType.UpdateGrade) {
    const { questionIndex, grade } = action.payload;
    state[questionIndex].grade = grade;
  }
  return state;
};
